import { render, staticRenderFns } from "./channel.vue?vue&type=template&id=b41e4f84&scoped=true&"
import script from "./channel.vue?vue&type=script&lang=ts&"
export * from "./channel.vue?vue&type=script&lang=ts&"
import style0 from "./channel.vue?vue&type=style&index=0&lang=less&"
import style1 from "./channel.vue?vue&type=style&index=1&id=b41e4f84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41e4f84",
  null
  
)

export default component.exports